var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInputSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8534 12.1467L10.2927 9.586C11.1487 8.57067 11.6667 7.262 11.6667 5.83333C11.6667 2.61667 9.05 0 5.83333 0C2.61667 0 0 2.61667 0 5.83333C0 9.05 2.61667 11.6667 5.83333 11.6667C7.262 11.6667 8.57069 11.1487 9.58602 10.2927L12.1466 12.8533C12.244 12.9507 12.372 13 12.5 13C12.628 13 12.756 12.9513 12.8534 12.8533C13.0487 12.6587 13.0487 12.342 12.8534 12.1467ZM1 5.83333C1 3.168 3.168 1 5.83333 1C8.49867 1 10.6667 3.168 10.6667 5.83333C10.6667 8.49867 8.49867 10.6667 5.83333 10.6667C3.168 10.6667 1 8.49867 1 5.83333Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputSearch);
export default __webpack_public_path__ + "static/media/input-search.710993f87710fdcbc8f347073bde9065.svg";
export { ForwardRef as ReactComponent };